import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { sumBy } from 'lodash'

import { makeGetOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder, makeGetOrderPreferencesByOrder, getPaymentByOrder } from '../../../selectors/suites'

import {
  addTipToOrder,
  startTabOrderAdjustmentAndClose,
} from '../../../actions/order'
import { fetchOrderingPreferences } from '../../../actions/suites/orderingPreference'

import Finalize from '../../../components/tabs/OrderDetailsModal/Finalize'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''

  const getOrder = makeGetOrder()
  const order = getOrder(state, orderId)
  const itemCount = sumBy(order.itemModels, 'quantity')
  const totalInCents = order?.amountInCents ?? 0
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const orderTotal = order?.orderTotalFromOrder ?? {}
  const paymentPreference = getPaymentByOrder(state, orderId)
  const getOrderingPreference = makeGetOrderPreferencesByOrder()
  const customerSettings = getOrderingPreference(state, orderId)
  const orderingPreference = customerSettings?.[order?.orderType] ?? {}
  const maxGratuity = orderingPreference?.maxGratuity

  const userNotes = order?.userNotes ?? ''

  return {
    ...order,
    suiteInformation,
    orderTotal,
    maxGratuity,
    itemCount,
    totalInCents,
    paymentPreference,
    userNotes,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}
  const orderDetailsPath = `/tabs/${orderId}`

  return {
    onClose: () => replace(orderDetailsPath),
    onMount: () => {
      dispatch(fetchOrderingPreferences())
    },
    finalizeOrder: (tipInCents, paymentPreference) => {
      dispatch(addTipToOrder(orderId, tipInCents))
      dispatch(startTabOrderAdjustmentAndClose({ orderId, adjustmentType: 'update', paymentPreference }))
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Finalize))
